import PropTypes from "prop-types";

import ActionButton from "../../../formInputs/buttons/ActionButton";

const SleComment = ({ canEdit, classSleComment, isOwned, loading, onSave, setValue, student, value }) => {
    return (
        <section className="section-card">
            <header className="section-card__header">
                <h5 className="section-card__title">School Level Expectations Comments</h5>
            </header>
            <div className="section-card__body comments-stack">
                {/* Class-wide sle comment */}
                {isOwned && (
                    <div className="comment-card">
                        <div className="comment-card__title">Class SLE Comment</div>
                        <div>
                            {classSleComment ? (
                                classSleComment
                            ) : (
                                <span style={{ fontStyle: "italic" }}>No comment entered</span>
                            )}
                        </div>
                    </div>
                )}
                <div className="comment-card">
                    <div className="comment-card__title">
                        {student.firstName} {student.lastName}&#39;s SLE Comment
                    </div>
                    <textarea
                        className="comment-textarea"
                        disabled={!canEdit}
                        rows={2}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder={`Add an SLE note for ${student.firstName}…`}
                    />
                    <div className="comment-actions">
                        <ActionButton
                            label={`Save ${student.firstName}'s SLE Comment`}
                            onClick={onSave}
                            disable={!canEdit || loading}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

SleComment.propTypes = {
    canEdit: PropTypes.bool,
    classSleComment: PropTypes.string,
    isOwned: PropTypes.bool,
    loading: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    student: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        studentNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    value: PropTypes.string.isRequired
};

SleComment.defaultProps = {
    canEdit: false,
    classSleComment: null,
    isOwned: false,
    loading: false
};

export default SleComment;
